import env from "config/env";
import { useFetchCurrentUserQuery } from "queries/user.queries";
import { useEffect } from "react";
import { useAccount } from "./useAccount";
import { useAppSelector } from "./useAppSelector";
import { UserDetails } from "features/types";
import { useQueryClient } from "@tanstack/react-query";
// utility hook that returns the current logged in user details, and their image identifier url
const useCurrentUser = () => {
  const { account } = useAccount();
  const storedUserId = useAppSelector((state) => state.auth.id);
  const { data: currentUser, refetch } = useFetchCurrentUserQuery(storedUserId);

  const userId = currentUser?.id;
  const currentMember = account?.members.find(
    (member) => member?.user.id === userId
  );
  const imageIdentifier = currentMember?.user.imageIdentifier;
  const userImageURL = `${env.fileUrl}/${imageIdentifier}`;

  const queryClient = useQueryClient();
  const updateCurrentUser = (user: UserDetails) => {
    queryClient.setQueriesData(["fetchCurrentUser", user.id], user);
  };

  useEffect(() => {
    const whiteListRoutes = ["Register", "AccountSetup"];
    if (!storedUserId && !whiteListRoutes.includes("Register")) {
      refetch();
    }
  }, [storedUserId]);

  return {
    currentUser,
    userImageURL,
    currentMember,
    fetchCurrentUser: refetch,
    isPrimary: currentMember?.type === "PRIMARY",
    updateCurrentUser,
  };
};

export default useCurrentUser;
